import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { renderHTMLString } from '../../../../helpers';

import SiteLayout from '../../../layouts/SiteLayout/SiteLayout';
import PersonHeader from '../../../sections/PersonHeader/PersonHeader';
import PersonContent from '../../../sections/PersonContent/PersonContent';
import PersonFooter from '../../../sections/PersonFooter/PersonFooter';
import PersonContentTable from '../../../sections/PersonContent/PersonContentTable/PersonContentTable';
import PersonContentList from '../../../sections/PersonContent/PersonContentList/PersonContentList';
import SponsorSpeakerDetails from '../../../sections/SponsorSpeakerDetails/SponsorSpeakerDetails';
import PersonSocialLinks from '../../../sections/PersonContent/PersonSocialLinks/PersonSocialLinks';
import FindUsAtSection from '../../../../informakit/components/FindUsAtSection';
import { ThemeContext } from 'styled-components';

function SponsorDetailsView(props) {
  const {
    siteHeader: {
      data: { title },
    },
    siteSponsorDetails: {
      data: details = {},
      meta: { title: contentTitle } = {},
    },
    options: {
      data: {
        liveAgenda,
        brand: { colours: brandColors },
      },
    },
    pageConfig: { location } = {},
  } = props;
  const themeConfig = useContext(ThemeContext);

  const isFanExpo = themeConfig?.name === 'FanExpo';

  const { t, i18n } = useTranslation();
  const hasSocialLinks = [
    'email',
    'facebook',
    'instagram',
    'linkedIn',
    'twitter',
    'url',
  ].some((socialId) => details[socialId]);

  const helmet = {
    title: `${contentTitle} | ${title}`,
    og: {
      description: `Organisation profile for ${details.name}`,
    },
  };

  return (
    <SiteLayout helmet={helmet}>
      <PersonHeader data={details} look="sponsor" />
      <PersonContent>
        <div className="c-person-content-section__column col-xs-12 col-sm-7">
          {details.profile && (
            <PersonContentTable header={t('event.organisation.profile')}>
              <div className="c-person-content-section__container">
                {renderHTMLString(details.profile, location)}
              </div>
            </PersonContentTable>
          )}
          {hasSocialLinks && (
            <PersonContentTable header={t('event.contact')}>
              <PersonSocialLinks contacts={details} />
            </PersonContentTable>
          )}
        </div>
        <div className="c-person-content-section__column col-xs-12 col-sm-5">
          <FindUsAtSection
            contacts={details.atEventContacts}
            brandColors={brandColors}
          />
          {details.relatedSessions?.length > 0 && (
            <PersonContentTable
              header={t('event.organisation.sponsored-sessions-title')}
            >
              <PersonContentList
                list={details.relatedSessions}
                locale={i18n.language}
              />
            </PersonContentTable>
          )}
          {details.spexSpeakers?.length > 0 && (
            <PersonContentTable
              header={
                details.speakerModuleTitle
                  ? details.speakerModuleTitle
                  : t('event.organisation.speaker-module-title')
              }
            >
              <SponsorSpeakerDetails
                spexSpeakers={details.spexSpeakers}
                sitePath={props.sitePath}
              />
            </PersonContentTable>
          )}
        </div>
      </PersonContent>
      <PersonFooter
        title={t('event.organisation.meet-us.title', { 0: details.name })}
        description={t(
          `event.organisation.meet-us.${
            isFanExpo ? 'message-exhibitors' : 'message'
          }`,
          { 0: title },
        )}
        liveAgenda={liveAgenda}
      />
    </SiteLayout>
  );
}

SponsorDetailsView.propTypes = {
  siteHeader: PropTypes.object,
  siteSponsorDetails: PropTypes.shape({
    data: PropTypes.shape({
      logo: PropTypes.object,
      name: PropTypes.string,
      profile: PropTypes.string,
      relatedSessions: PropTypes.array,
      linkedIn: PropTypes.string,
      twitter: PropTypes.string,
      facebook: PropTypes.string,
      url: PropTypes.string,
      email: PropTypes.string,
      speakerModuleTitle: PropTypes.string,
      spexSpeakers: PropTypes.array,
      atEventContacts: PropTypes.shape({
        location: PropTypes.string,
        name: PropTypes.string,
        email: PropTypes.string,
        phone: PropTypes.string,
      }),
    }),
    meta: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  options: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    siteHeader: state.siteHeader,
    siteSponsorDetails: state.siteSponsorDetails,
    options: state.options,
    sitePath: state.pageConfig.sitePath,
    pageConfig: state.pageConfig,
  };
}

export default connect(mapStateToProps)(SponsorDetailsView);
